module.exports = __webpack_public_path__ + "static/media/demo_final.5a17cb2b.gif";